<template>
  <div>
    <div v-if="!linkInvalid">
      <h1>Verifying Link...</h1>
    </div>

    <div v-if="linkInvalid">
      <h1>Link Expired or Invalid</h1>
      <p>
        It looks like this 'magic' link is expired or invalid. Please email dave@unfundedlist.com if
        this continues to happen.
      </p>
    </div>
  </div>
</template>

<script>
import Auth from '@/services/auth'
import store from '@/vuex/store'

export default {
  name: 'MagicLinkReport',
  data() {
    return {
      linkInvalid: false,
    }
  },
  created() {
    this.$store.commit('LOGOUT_USER')
    const userId = this.$route.query.uid
    const magicToken = this.$route.query.token
    const appId = this.$route.query.appid
    const magicTokenReport = this.$route.query.uuid
    var url = 'https://'+window.location.hostname+'/application-reports/'+appId+'/'

    //console.log(userId)
    //console.log(magicToken)
    //alert(url)
    // Call endpoint with the user's ID and magic token
    
    Auth.magicLinkReportAuth(userId, magicToken)
      .then(data => {
        this.$store.commit('UPDATE_USER', {
          user: data,
          authToken: data.token,
        })
        this.$Alert.alert({
          type: 'info',
          message: `<p>Welcome to UnfundedList, ${this.$store.state.user.first_name} ${this.$store.state.user.last_name}!</p>`,
          timeout: 6000,
        })
        //window.location.href =url;
      })
      .catch(error => {
        // On failure, show failure message
        this.linkInvalid = true
        throw error
      })
      
  },
}
</script>

<style lang="scss" scoped></style>
